<script setup>
/*
========================================================================
SizeGuide.vue

Collapsible size guide component that displays product dimension images.
Used in product selection modals to show/hide size reference images.
========================================================================
*/
import { ref } from "vue";
import { PhCaretUp, PhCaretDown } from "@phosphor-icons/vue";

/*
------------------------------------------------------------------------
Props
------------------------------------------------------------------------
*/
const props = defineProps({
	// Array of image URLs for the size guide
	images: {
		type: Array,
		required: true,
	},
	// Product name for alt text
	productName: {
		type: String,
		default: "product",
	},
	// Additional wrapper classes (e.g., for bottom padding)
	wrapperClass: {
		type: String,
		default: "",
	},
});

/*
------------------------------------------------------------------------
Local State
------------------------------------------------------------------------
*/
const isOpen = ref(false);

const toggleSizeGuide = () => {
	isOpen.value = !isOpen.value;
};
</script>

<template>
	<div :class="wrapperClass">
		<button
			type="button"
			class="lux-btn lux-btn-xsmall flex items-center gap-2"
			:class="{ 'lux-btn-black': isOpen, 'lux-btn-outline': !isOpen }"
			@click="toggleSizeGuide"
		>
			<PhCaretUp :size="16" weight="fill" v-show="isOpen" />
			<PhCaretDown :size="16" weight="fill" v-show="!isOpen" />
			Size Guide
		</button>
		<div v-show="isOpen" class="mt-5">
			<img
				v-for="img in images"
				:key="img"
				class="mx-0 mb-5 w-full"
				:src="img"
				:alt="`Size guide for ${productName}.`"
			/>
		</div>
	</div>
</template>
